import React from "react"
import { Link, graphql, navigate } from "gatsby"
import Layout from "../components/Layout"
import SEO from "../components/Seo"
import MovieCard from "../components/MovieCard"
import { isLoggedIn } from "../auth.js"

const IndexPage = ({ data }) => {
  if (typeof window !== "undefined") {
    if (!isLoggedIn()) {
      navigate("/login")
      return null
    }
  }

  const { movies } = data

  return (
    <Layout>
      <SEO title="Home" />
      {movies.edges.map(({ node }) => (
        <Link to={`/movie/${node.id}`} key={node.id}>
          <MovieCard key={node.id} {...node} />
        </Link>
      ))}
    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  query {
    movies: allMoviesJson(skip: 0, limit: 10) {
      edges {
        node {
          id
          title
          poster
          overview
          genres
        }
      }
    }
  }
`
